module.exports = ".banner {\n  margin-bottom: 20px; }\n\nh1 {\n  margin-top: 40px; }\n"